<template>
    <main class="recommend-detail-page">
        <div class="screenFull" v-if="inited"><div class="skeletonbx"><van-skeleton title row="7"></van-skeleton></div></div>

        <template v-if="match">
            <section class="detail-match-card">
                <div class="detail-match-meta"><b>{{match.match_type}}</b><time>{{match.match_time}}</time></div>
                <div class="detail-versus">
                    <div><team-badge :name="match.shangpan" :size="46"/><strong>{{match.shangpan}}</strong></div>
                    <span><small>赛事对阵</small><em>{{match.bifen || 'VS'}}</em></span>
                    <div><team-badge :name="match.xiapan" :size="46"/><strong>{{match.xiapan}}</strong></div>
                </div>
                <nav class="detail-tabs"><button :class="tabIndex===1?'curr':''" @click="changeTab(1)">专家分析</button><button :class="tabIndex===2?'curr':''" @click="changeTab(2)">全部方案 {{list_size}}</button></nav>
            </section>

            <section v-if="tabIndex === 1" class="detail-content-panel">
                <div class="market-data-row">
                    <div><small>让球数据</small><span><b>主队</b><strong>{{match.pk}}</strong><b>客队</b></span></div>
                    <div><small>大小数据</small><span><b>大球</b><strong>{{match.dxp}}</strong><b>小球</b></span></div>
                    <button @click="showPublishPopBox" v-if="publish">我要发布</button>
                </div>
                <p class="match-description" v-if="match.desc">{{match.desc}}</p>

                <article v-if="recommend" class="expert-report-card">
                    <header class="report-expert-head">
                        <router-link :to="'/member/'+recommend.user.id" class="report-expert">
                            <img :src="recommend.user.portrait || defimg" @error="$event.target.src=defimg"/>
                            <span><b>{{recommend.user.name}} <i>认证专家</i></b><small>{{recommend.user.intro}}</small><time>{{recommend.create}}发布</time></span>
                        </router-link>
                        <span class="report-label" v-if="recommend.mycommend">我的推介</span>
                        <span class="report-label consumed" v-else-if="recommend.isconsume">已订阅</span>
                    </header>
                    <div class="report-metrics"><span><b>{{recommend.user.winrate || 0}}%</b><small>7天胜率</small></span><span><b>{{recommend.roi || 0}}%</b><small>推荐回报率</small></span><span><b>{{recommend.stability || 0}}%</b><small>稳定性</small></span><span><b>{{recommend.hot_sales || 0}}</b><small>订阅热度</small></span></div>
                    <div class="report-analysis" v-if="recommend.commend_desc"><b>推荐分析</b><p>{{recommend.commend_desc}}</p></div>
                    <footer class="report-conclusion">
                        <span :class="'report-result rs'+recommend.result_id">{{recommend.result_id == 1 ? '等待赛果' : recommend.result}}</span>
                        <div class="report-direction" v-if="recommend.showtype == 1"><small>推荐结论</small><strong>待公开</strong></div>
                        <div class="report-subscribe" v-else-if="recommend.showtype == 2"><span><small>订阅后查看推荐结论</small><b>{{recommend.gold}} 球币</b></span><button @click="ding(recommend.uuid, recommend.gold)">支付查看</button></div>
                        <div class="report-direction revealed" v-else><small>推荐结论</small><strong>{{recommend.commend}}</strong></div>
                    </footer>
                </article>
            </section>

            <section v-if="tabIndex === 2" class="detail-content-panel scheme-panel">
                <div class="scheme-head"><span>认证专家</span><span>专业数据</span><span>推荐结论</span><span>发布 / 赛果</span></div>
                <van-list v-if="list.length" v-model="loading" :immediate-check="false" :finished="finished" finished-text="没有更多内容了" @load="onLoad">
                    <div class="scheme-list">
                        <div v-for="(c,i) in list" :key="i" class="scheme-row">
                            <router-link :to="'/member/'+c.user.id" class="scheme-expert"><img :src="c.user.portrait || defimg" @error="$event.target.src=defimg"><span><b>{{c.user.name}} <i>认证</i></b><small>{{c.user.intro}}</small></span></router-link>
                            <div class="scheme-metrics"><span><b>{{c.user.winrate || 0}}%</b>7天胜率</span><span><b>{{c.roi || 0}}%</b>回报率</span><span><b>{{c.stability || 0}}%</b>稳定性</span><span><b>{{c.hot_sales || 0}}</b>订阅热度</span></div>
                            <div class="scheme-direction"><strong v-if="c.showtype == 3 || c.showtype == 4">{{c.commend}}</strong><button v-else-if="c.showtype == 2" @click="ding(c.uuid, c.gold)">{{c.gold}} 球币查看</button><strong v-else>待公开</strong></div>
                            <div class="scheme-status"><time>{{c.create}}发布</time><b :class="'rs'+c.result_id">{{c.result || '等待赛果'}}</b></div>
                        </div>
                    </div>
                </van-list>
                <div v-else class="member-empty">暂无其他方案</div>
            </section>
        </template>

        <Publish v-if="showPublishPopup"></Publish>
    </main>
</template>

<script>
    import defPortrait from "../assets/images/default-analyst-v3.jpg"
    import Publish from "./public/publish";
    import TeamBadge from "./public/team_badge";
    export default {
        name: "recommend_view",
        components: {Publish, TeamBadge},
        comments: {
            Publish
        },
        inject: ['reload'], //注入reload方法(在App.vue)
        data() {
            return {
                inited: true,
                match: null,
                tabIndex: 1,
                list: [],
                list_size: 0,
                recommend: null,
                loading: true,
                finished: false,
                isloading: false,
                defimg: defPortrait,
                rid: null,
                mid: null,

                showPublishPopup: false,
                selectMatchId: 0,
                publish: false,

                formPath: '',
            }
        },

        created() {
            //let that = this
            // console.log('created')
            // let rid = this.$route.params.rid   //推介id
            // let mid = this.$route.params.mid  //赛事id
            // console.log(rid)
            // console.log(mid)
            //that.rid = rid
            //that.mid = mid
            //that.getList()
        },
        activated() {
            let that = this
            // console.log('activated')
            let rid = this.$route.params.rid   //推介id
            let mid = this.$route.params.mid  //赛事id
            that.rid = rid
            that.mid = mid
            // console.log(rid)
            // console.log(mid)
            that.finished = false
            that.list = []
            that.match = null
            that.recommend = null
            that.inited = true
            that.getList()
        },
        methods: {
            changeTab(i){
              this.tabIndex = i
            },
            onLoad() {
                let that = this
                setTimeout(function () {
                    //console.log(that.pageIndex)
                    that.pageIndex++
                    that.getList()
                }, 500)
            },
            getList(){
                let that = this
                // console.log(that.rid)
                // console.log(that.finished)
                // console.log(that.isloading)
                if(that.finished) return
                if(that.isloading) return
                that.isloading = true
                // console.log('start')
                that.$post(that.$api.recommend_view, {rid: that.rid, mid: that.mid}).then(function (res) {
                    // console.log(res)
                    that.isloading = false
                    that.loading = false

                    that.list_size = res.data.list_size
                    that.match = res.data.match
                    if(that.match){
                        document.title = that.match.shangpan + 'vs' + that.match.xiapan + that.$get_config_text.title
                    }
                    that.mid = res.data.match.id
                    if(res.data.recommend) {
                        that.recommend = res.data.recommend
                        if(that.recommend.user.portrait==null) {
                            that.recommend.user.portrait = ''
                        }else{
                            that.recommend.user.portrait = that.$api.imgBaseUrl + that.recommend.user.portrait
                        }
                    }
                    //console.log(that.recommend)

                    let list = res.data.recommend_list
                    if(list.length>0) {
                        list.forEach(function (i) {
                            if(i.user.portrait)
                                i.user.portrait = that.$api.imgBaseUrl + i.user.portrait
                        })
                        that.list = that.list.concat(list)
                        if (list.length < 20)
                            that.finished = true
                    }
                    else{
                        that.finished = true
                    }

                    that.publish = res.data.publish || false
                }).catch(function () {
                    //console.log(res)
                    that.$toast.fail('读取失败')
                    that.finished = true
                }).finally(function () {
                    that.inited = false
                })
            },
            ding(id, gold){
                let that = this
                let token = that.$store.state.token
                if(token === null || token === '' || token === undefined){
                    that.$store.commit('SHOW_LOGINPOP')
                    return
                }
                that.$dialog.confirm({
                    title: '确认',
                    message: '确定订阅本场推介, 消费'+gold+'球币？',
                }).then( () => {
                    that.$toast.loading()
                    that.$post(that.$api.recommend_subscribe, {rid: id}).then(function (res) {
                        //console.log(res)
                        if(res.code === 1){
                            that.$toast.success(res.msg)
                            //that.reload()  调用App.vue中reload
                            that.recommend.showtype = 3
                            that.recommend.isconsume = true
                            that.recommend.commend = res.data.commend
                        }
                        else{
                            that.$toast.fail(res.msg)
                        }
                    })
                }).catch( () => {
                    //no fun
                })
            },

            showPublishPopBox(){
                let token = this.$store.state.token, that = this
                if(token === null || token === '' || token === undefined){
                    //this.$toast({message: '请登录'})
                    that.$store.commit('SHOW_LOGINPOP')
                    return
                }
                that.showPublishPopup = true
                that.selectMatchId = that.mid
            },
            publishSuccess(){
                //发布推介成功
                let that = this
                that.showPublishPopup = false
            },
            closePublishPopBox(){
                //关闭发布弹窗
                let that = this
                that.showPublishPopup = false
            },
            goBack(){
                // this.$router.push({
                //     path: '/recommend'
                // })
                let that = this
                this.$router.push({
                    path: that.formPath === '' ?'/recommend':that.formPath
                    // path: '/'
                })
            }
        },
        beforeRouteEnter(to, form, next){
            next(vm => {
                vm.formPath = form.path
            })
        }
    }
</script>

<style scoped>
</style>
